import { render, staticRenderFns } from "./CategoryInformation.vue?vue&type=template&id=708f6e44&scoped=true"
import script from "./CategoryInformation.vue?vue&type=script&lang=js"
export * from "./CategoryInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708f6e44",
  null
  
)

export default component.exports